import React from 'react';
import ProductCatalogs from './ProductCatalogs';
import { initReactApp } from 'shared/util/ApplicationInit';

const render = initReactApp(() => <ProductCatalogs />, 'product-catalogs');

render();

// optional, use this to enable hot reloading
if ((module as any).hot) {
	(module as any).hot.accept('./ProductCatalogs', () => {
		render();
	});
}
